import * as yup from "yup";

export const CostPlusEditValidation = yup.object().shape({
  creditCostPlus: yup
    .number()
    .typeError("Credit Cost Plus - TA Petro must be a number")
    .required("Credit Cost Plus - TA Petro is required"),
  prepaidCostPlus: yup
    .number()
    .typeError("Prepaid Cost Plus - TA Petro must be a number")
    .required("Prepaid Cost Plus - TA Petro is required"),
  creditCostPlusLoves: yup
    .number()
    .typeError("Credit Cost Plus - Loves must be a number")
    .required("Credit Cost Plus - Loves is required"),
  prepaidCostPlusLoves: yup
    .number()
    .typeError("Prepaid Cost Plus - Loves must be a number")
    .required("Prepaid Cost Plus - Loves is required"),
  costPlus: yup
    .number()
    .typeError("Cost Plus must be a number")
    .required("Cost Plus is required"),
  distanceRadius: yup
    .number()
    .typeError("Distance Radius must be a number")
    .positive("Distance Radius must be positive")
    .required("Distance Radius is required"),
});
